export default "__VITE_PUBLIC_ASSET__23dc30f8__"